module.exports = __webpack_public_path__ + "img/sms.421b6ce8.svg";